__turbopack_context__.v({
  "className": "MnMIKa_className",
  "variable": "MnMIKa_variable",
});
